
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';
    import { ControladorChatActivo } from '@view/a-chat-2/pc/lista/sala/controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorChatActivo;
        public get NuevoMensaje() { return this.Controlador.NuevoMensaje; };
        public get SubiendoArchivo() { return this.Controlador.NuevoMensaje.SubiendoArchivo; };
        public get EnviandoMensaje() { return this.Controlador.NuevoMensaje.EnviandoMensaje; };

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        public Focused: boolean = false;
        public SeleccionarArchivo: boolean = false;
        public SeleccionarImagen: boolean = false;

        mounted()
        {

        }

        async AgregarFactura( x: File )
        {
            this.Controlador.ControladorBarrasLaterales.Vista.Modo = 'facturas';
        }

        async AgregarArchivo( x: File )
        {
            if ( x )
            {
                let e = await this.NuevoMensaje.AgregarArchivo( x );
                if ( e == 'demasiado-grande' )
                {
                    Utiles.Notificaciones.Error( '¡El archivo es demasiado grande!' );
                }
                else if ( e == 'error' )
                {
                    Utiles.Notificaciones.Error( '¡Error al subir el archivo!' );
                }
            }

        }

        public async EnviarDeclaracionJurada()
        {
            let file: { Nombre: string; Ruta: string; } = { Nombre: '', Ruta: '' };
            if ( this.Controlador.Chat.Cuenta == 'DR.LINEABLANCA' || this.Controlador.Chat.Cuenta == 'CASA_JARSE_SAIC' )
            {
                file.Nombre = 'dj_casa_jarse.pdf';
                file.Ruta = '/declaraciones/dj_casa_jarse.pdf';
            } else
            {
                file.Nombre = 'dj_jarse_industrial.pdf';
                file.Ruta = '/declaraciones/dj_jarse_industrial.pdf';
            }

            if ( file.Nombre )
            {
                let e = await this.NuevoMensaje.AgregarArchivoEstatico( file );
                if ( e == 'demasiado-grande' )
                {
                    Utiles.Notificaciones.Error( '¡El archivo es demasiado grande!' );
                }
                else if ( e == 'error' )
                {
                    Utiles.Notificaciones.Error( '¡Error al subir el archivo!' );
                }
            }

        }
    }
